import ScienceHome from "./ScienceHome";
import SciencePillar from "./SciencePillar";
import ScienceConcept from "./ScienceConcept";
import ScienceToday from "./ScienceToday";

/** Science Pulse route manifest — docket pattern (see farmers_pulse). */
export const ROUTES = [
  { name: "sp-home", path: "/science", standalonePath: "/", element: <ScienceHome /> },
  { name: "sp-today", path: "/science/today", standalonePath: "/today", element: <ScienceToday /> },
  { name: "sp-pillar", path: "/science/:pillar", standalonePath: "/pillar/:pillar", element: <SciencePillar /> },
  { name: "sp-concept", path: "/science/concept/:conceptId", standalonePath: "/concept/:conceptId", element: <ScienceConcept /> },
];

export function toStandalonePath(path, standalonePath) {
  return standalonePath || path.replace(/^\/science/, "") || "/";
}
